import * as React from "react";

import {t} from "i18next";

import SelectField, {OptionValue} from "../../../components/SelectField";
import Button from "../../../components/Button";

import {ModeltypeBasicDto} from "../../../services/Client";
import {DerivateUtils} from "../../../components/Table/components/derivate/DerivateUtils";

interface ISelectDerivatesTransferProps {
    derivates: ModeltypeBasicDto[];
    sourceMTB?: ModeltypeBasicDto;
    targetMTBs?: ModeltypeBasicDto[];
    userLanguage: string;

    onChange: (source: ModeltypeBasicDto, target: ModeltypeBasicDto[]) => void;
    nextAction: () => void;
}

export const AMTBSelectContexts = (props: ISelectDerivatesTransferProps) => {
    return (
        <>
            <div>
                <span className={'amtb-transfer-select-context-header'}>
                    {t("AMTB_TRANSFER:SOURCE_DERIVATE")}
                </span>
                <SelectField
                    placeholder={t("AMTB_TRANSFER:SELECT_DERIVATE")}
                    value={props.sourceMTB}
                    dataSource={props.derivates}
                    rendererKey={(value: OptionValue) => DerivateUtils.renderKeyDerivate(value as ModeltypeBasicDto, props.userLanguage)}
                    clearable={true}
                    searchable={true}
                    onChange={(value: ModeltypeBasicDto) => props.onChange(value, [])}
                />
            </div>

            <div className={'margin-top--10px'}>
                <span className={'amtb-transfer-select-context-header'}>
                    {t("AMTB_TRANSFER:TARGET_DERIVATES")}
                </span>
                <SelectField
                    placeholder={t("AMTB_TRANSFER:SELECT_DERIVATE")}
                    value={props.targetMTBs}
                    dataSource={props.derivates.filter((dto: ModeltypeBasicDto) => props.sourceMTB && dto.objectId !== props.sourceMTB.objectId)}
                    rendererKey={(value: OptionValue) => DerivateUtils.renderKeyDerivate(value as ModeltypeBasicDto, props.userLanguage)}
                    clearable={true}
                    searchable={true}
                    readonly={!props.sourceMTB}
                    multi={true}
                    onChange={(values: any[]) => props.sourceMTB && props.onChange(props.sourceMTB, values.map((v) => v.selectedValue as ModeltypeBasicDto))}
                />
            </div>

            <div style={{marginTop: '20px', textAlign: 'right'}}>
                <Button
                    icon={'arrow right'}
                    disabled={!props.sourceMTB || !props.targetMTBs || props.targetMTBs.length === 0}
                    onClick={props.nextAction}
                />
            </div>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/amtbTransfer/AMTBSelectContexts.tsx